import React, { useState } from "react"
import DataTable from "aldoo-ra/DataTable"
import Typography from "aldoo-ra/Typography"
import { formatBytes } from "aldoo-ra/Admin/KPI/format"
import { ListTransfers } from "./api"
import { StatusBadge, formatDate, Owner } from "./ui"
import FilesDialog from "./FilesDialog"

const TransfersTab = () => {
  const [openOrder, setOpenOrder] = useState(null)

  const columns = [
    {
      id: "name",
      header: "Transfer",
      sortable: true,
      render: (_, item) => (
        <button
          className="text-admin_primary hover:underline text-left font-medium"
          onClick={() => setOpenOrder(item.orderID)}
        >
          {item.fileName || item.orderID}
        </button>
      ),
    },
    {
      id: "owner",
      header: "Owner",
      render: (_, item) => <Owner owner={item.owner} />,
    },
    {
      id: "status",
      header: "Status",
      sortable: true,
      render: (_, item) => <StatusBadge status={item.expired ? "expired" : item.status} />,
    },
    {
      id: "files",
      header: "Files",
      sortable: true,
      render: (_, item) => <span>{item.fileCount}</span>,
    },
    {
      id: "size",
      header: "Size",
      sortable: true,
      render: (_, item) => <span className="whitespace-nowrap">{formatBytes(item.totalSize)}</span>,
    },
    {
      id: "downloads",
      header: "Downloads",
      render: (_, item) => (
        <span className="text-admin_text_secondary">
          {item.downloadCount}
          {item.downloadLimit != null ? ` / ${item.downloadLimit}` : ""}
        </span>
      ),
    },
    {
      id: "created",
      header: "Created",
      sortable: true,
      render: (_, item) => <span className="whitespace-nowrap">{formatDate(item.created)}</span>,
    },
    {
      id: "expires",
      header: "Expires",
      render: (_, item) => <span className="whitespace-nowrap">{formatDate(item.expires)}</span>,
    },
  ]

  return (
    <div>
      <DataTable
        variant="admin_browser"
        apiMethod={ListTransfers}
        searchField="q"
        searchPlaceholder="Search file name, owner, order ID…"
        sort={{ created: -1 }}
        localUserPreferencesKey="admin.transferBrowser.transfers"
        renders={columns}
        preferredHeight="60vh"
        itemHeight="h-14"
        noData={<Typography variant="admin_body">No transfers found</Typography>}
      />
      <FilesDialog orderID={openOrder} onClose={() => setOpenOrder(null)} />
    </div>
  )
}

export default TransfersTab
